import React, { Component, type SyntheticEvent } from 'react';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import Error from '../../common/ui/view-workflow/error/index.tsx';
import type { ServiceApi } from '../../services/view-workflow-service/index.tsx';
import ViewWorkflowClassic from './classic/index.tsx';
import { ViewWorkflowModalDropDownTrigger } from './read-view-modal/index.tsx';

type IssueKey = string;
type IssueTypeId = string;
type ProjectId = string;

export type Props = {
	issueKey: IssueKey;
	workflowServiceApi: ServiceApi;
	onCloseModal?: () => void;

	// TODO: Remove after workflow modal dependency is cleaned up in plans
	isModalMounted?: boolean;
	onOpenModal?: (issueTypeId: IssueTypeId, projectId: ProjectId) => void;
};

type State = {
	isWorkflowServiceRefetching: boolean;
};

// eslint-disable-next-line jira/react/no-class-components
export default class ViewWorkflow extends Component<Props, State> {
	state: State = {
		isWorkflowServiceRefetching: false,
	};

	onWorkflowServiceRefetch = async (e: SyntheticEvent<HTMLElement>, retry: () => Promise<void>) => {
		e.stopPropagation();
		this.setState({
			isWorkflowServiceRefetching: true,
		});

		await retry();
		this.setState({
			isWorkflowServiceRefetching: false,
		});
	};

	render(): React.JSX.Element | null {
		const { issueKey, workflowServiceApi, onCloseModal } = this.props;
		const { isWorkflowServiceRefetching } = this.state;

		const { data, loading, error, fetch } = workflowServiceApi;

		if (error) {
			return (
				<Error
					onRetry={(e) => {
						this.onWorkflowServiceRefetch(e, fetch);
					}}
				/>
			);
		}

		if (!data) {
			return null;
		}

		const { isSimplified, projectId, issueTypeId, hasPermission } = data;

		if (!isSimplified && fg('legacy_readonly_workflow_modal_optin')) {
			return (
				<ViewWorkflowClassic
					issueKey={issueKey}
					hasPermission={hasPermission}
					isServiceLoading={loading}
					isServiceRefetching={isWorkflowServiceRefetching}
				/>
			);
		}

		if (!projectId) {
			log.safeErrorWithoutCustomerData(
				'issue-field-status.view-workflow.no-project-id',
				'WorkflowServiceApi finished loading but there was no projectId',
			);
			return null;
		}

		return (
			<ViewWorkflowModalDropDownTrigger
				issueKey={issueKey}
				projectId={projectId}
				issueTypeId={issueTypeId}
				isSimplifiedProject={isSimplified}
				hasPermission={hasPermission}
				isServiceLoading={loading}
				isServiceRefetching={isWorkflowServiceRefetching}
				onClose={onCloseModal}
			/>
		);
	}
}
